<script>
import Label from './Label.vue'

export default {
    props: {
        item: {
        type: Object,
        required: true,
        },
        selectedItem: {
        type: Object,
        required: false
        },
        updateValue: {
          type: Function,
          required: true
      },
    },
    components: {
        Label
    },
    data() {
        return {
        };
    },   
    computed: {
        bordercolor() {
            return (this.selectedItem?.additionalProp1?.color) ? this.selectedItem.additionalProp1.color : '#715bff'
        },
        devlopermode() {
            return this.$route?.query?.devlopermode && this.$route?.query?.devlopermode === 'true' || false
        }
    },
    methods: {
        updatevalue(val) {
                this.updateValue(this.item_key, val);
        }

    },
    watch: {
    }
};
</script>
<template>
    <div class="mb-3">
        <Label :item="item"/>
        <div class="cards-scrollable-item">
            <a :href="selectedItem.link_url" tabindex="0" role="button" class="quick-link-card">
                <div class="quick-link-card-top join-the-practice" :style="{borderColor: bordercolor}">
                    <span class="svg-icon">
                        <img :src="selectedItem.additionalProp1 && selectedItem.additionalProp1.icon">
                    </span>
                </div>
                <div class="quick-link-card-bottom font-weight-medium">
                    {{selectedItem.label}}
                </div>
            </a>
            <template v-if="selectedItem.additionalProp1 && devlopermode">
            <div class="mT20">Enter Img URL</div>
            <input
                v-model="selectedItem.additionalProp1.icon"
                type="text"
                class="form-control mT5"
            
                placeholder="Enter icon url"
            />
            </template>
           
        </div>
    </div>
</template>
<style scoped>
.svg-icon {
    display: inline-block;
    position: relative;
}
.quick-link-card-top.join-the-practice {
    border-top: 4px solid;
    border-color: #715bff;
    background-color: #ffffff;
}
.quick-link-card-top {
    height: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.quick-link-card {
    display: block;
    width: 152px;
    /* height: 180px; */
    text-decoration: none;
    transition: transform .2s ease-in;
    outline: none;
    /* margin-bottom: 1em; */
}
.quick-link-card-bottom {
    height: 62px;
    padding: 14px 16px;
    padding-top: 0;
    color: #000;
    font-size: 14px;
    /* letter-spacing: 0; */
    /* line-height: 21px; */
    font-weight: 600;
    background-color: #fff;
    text-align: center;
}
.mT20 {
    margin-top: 20px;
}
.mT5 {
    margin-top: 5px;
}
</style>